<template>
  <div>
    <el-form ref="form" label-width="80px">
      <el-row>
        <el-col :span="12">
          <el-form-item label="账号名:">
            <el-input disabled v-model="user.account"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="姓名:">
            <el-input disabled v-model="user.name"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12" v-if="$store.state.usuerdata.role == 1">
          <el-form-item label="班级:">
            <el-input disabled v-model="classlistData.name"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="学校:">
            <el-select disabled v-model="user.schoolId" placeholder="请选择">
              <el-option
                v-for="item in listData"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="">
            <el-button type="primary" size="mide" @click="handleEdit">
              编辑</el-button
            >
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-dialog title="编辑账号" :visible.sync="edVisible" width="30%">
      <el-form
        label-width="120px"
        :model="edfromData"
        :rules="edrules"
        ref="edForm"
      >
        <el-form-item label="新姓名" prop="new_name">
          <el-input
            size="small"
            v-model="edfromData.new_name"
            auto-complete="off"
            placeholder="请输入新姓名"
          ></el-input>
        </el-form-item>
        <el-form-item label="原密码" prop="old_password">
          <el-input
            size="small"
            v-model="edfromData.old_password"
            auto-complete="off"
            placeholder="请输入原密码"
          ></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="new_password">
          <el-input
            size="small"
            v-model="edfromData.new_password"
            auto-complete="off"
            placeholder="请输入新密码"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="edVisible = false">取消</el-button>
        <el-button
          size="small"
          type="primary"
          :loading="loading"
          class="title"
          @click="submitFormed('edForm')"
          >保存
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { myinfos, schoollist, myedit, classinfo } from "@/api/userMG";
export default {
  name: "index",
  data() {
    return {
      user: {},
      listData: [],
      edfromData: {
        old_password: "",
        new_password: "",
        new_name: "",
      },
      loading: false, //是显示加载
      edrules: {
        old_password: [
          { required: true, message: "请输入原密码", trigger: "blur" },
        ],
        new_password: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          { validator: this.$pswcheck, trigger: "blur" },
        ],
        new_name: [
          { required: true, message: "请输入新姓名", trigger: "blur" },
        ],
      },
      edVisible: false,
      classlistData: [],
    };
  },
  created() {
    this.getmyinfos();
    this.getdata();
  },
  methods: {
    getClass() {
      classinfo().then((res) => {
        this.classlistData = [];
        this.classlistData = res;
      });
    },
    handleEdit() {
      this.edVisible = true;
      this.edfromData.old_password = "";
      this.edfromData.new_password = "";
      this.edfromData.new_name = "";

      this.edfromData.new_name = this.user.name;
    },
    submitFormed(edForm) {
      this.$refs[edForm].validate((valid) => {
        if (valid) {
          if (!this.$pswtest(this.edfromData.new_password)) {
            this.$message.warning(
              "密码必须是大写字母，小写字母，数字，特殊字符组成，且长度为8到12位！"
            );
            return;
          }
          myedit(this.edfromData)
            .then((res) => {
              this.edVisible = false;
              this.loading = false;
              this.$message({
                type: "success",
                message: "修改成功！",
              });
              this.getmyinfos();
            })
            .catch((err) => {
              this.edVisible = false;
              this.loading = false;
              this.$message.error(err.response.data.msg);
            });
        }
      });
    },
    getmyinfos() {
      myinfos().then((res) => {
        console.log("🚀  myinfos 222 res:", res);
        this.user = {};
        this.user = res;
        if (this.$store.state.usuerdata.role == 1) {
          this.getClass(this.user);
        }
      });
    },
    getdata() {
      schoollist().then((res) => {
        this.listData = [];
        this.listData = res;
        console.log(res, "resss");
      });
    },
  },
};
</script>
<style >
</style>



// WEBPACK FOOTER //
// src/views/my/myinfo.vue